<template>
  <div class="container">
    <v-row v-if="loadingRecord">
      <v-col class="text-center">loading</v-col>
    </v-row>
    <div v-else>
      <v-row v-if="reportItems.length">
        <v-col cols="3" v-for="(val, index) in reportItems" :key="index">
          <template v-if="Object.keys(val).includes('diagnosis')">
            <v-hover v-slot="{ hover }">
              <div :class="{ 'grey lighten-3': hover }">
                <v-col cols="12" class="text-h6 font-weight-bold">
                  <v-row>
                    <v-col>
                      {{ val.hText }}
                    </v-col>
                    <v-col v-if="hover" class="d-flex">
                      <v-btn
                        class="small mx-2 error"
                        @click="deleteItem(val.id)"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-btn
                        class="small mx-2 warning"
                        @click="editItem(val.id)"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div class="text-body-1 font-weight-bold">Tgl. Periksa</div>
                  <div class="text-subtitle-1">
                    {{ formatDate(val.examined_at) }}
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="text-body-1 font-weight-bold">Diagnosa</div>
                  <div class="text-subtitle-1">
                    {{ val.diagnosis }}
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="text-body-1 font-weight-bold">Pengobatan</div>
                  <div v-for="(kategori, idx) in val.pengobatan" :key="idx">
                    <div class="text-subtitle-1" v-if="idx !== 'common'">
                      {{
                        idx === "otherHeart"
                          ? "Obat Jantung Lain"
                          : "Obat Non Jantung"
                      }}
                    </div>
                    <div v-for="(item, idxSub) in kategori" :key="idxSub">
                      <v-span v-if="item.value"
                        >{{ item.name }} | {{ item.dosis }} |
                        {{ item.note }}</v-span
                      >
                    </div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="text-body-1 font-weight-bold">
                    Penampilan Klinis
                  </div>
                  <div
                    v-for="(item, idx) in penampilanKlinisKategori"
                    :key="idx"
                  >
                    <v-span v-if="val.penampilanKlinis[item.index] !== null">
                      <v-span v-if="val.penampilanKlinis[item.index] === true"
                        ><v-icon>mdi-check</v-icon> {{ item.name }}
                      </v-span>

                      <v-span v-else
                        >{{ item.name }}:
                        {{ val.penampilanKlinis[item.index] }}</v-span
                      >
                    </v-span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="text-body-1 font-weight-bold">Status Gizi</div>
                  <div v-for="(item, idx) in statusGiziCategory" :key="idx">
                    <v-span v-if="val.statusGizi[item.index] !== null">
                      <v-icon v-if="val.statusGizi[item.index] === true"
                        >mdi-check</v-icon
                      >
                      <v-icon v-else-if="val.statusGizi[item.index] === false"
                        >mdi-close</v-icon
                      >
                      {{ item.name
                      }}<v-span v-if="val.statusGizi[item.index].length > 0"
                        >: {{ val.statusGizi[item.index] }}</v-span
                      >
                    </v-span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="text-body-1 font-weight-bold">
                    Optimalisasi Dosis
                  </div>
                  <div
                    v-for="(item, idx) in optimalisasiDosisCategory"
                    :key="idx"
                  >
                    <v-span v-if="val.optimalisasiDosis[item.index] !== null">
                      <v-span v-if="val.optimalisasiDosis[item.index] === true"
                        ><v-icon>mdi-check</v-icon> {{ item.name }}
                      </v-span>

                      <v-span
                        v-else-if="val.optimalisasiDosis[item.index] === false"
                        ><v-icon>mdi-close</v-icon> {{ item.name }}
                      </v-span>

                      <v-span v-else
                        >{{ item.name }}:
                        {{ val.optimalisasiDosis[item.index] }}</v-span
                      >
                    </v-span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="text-body-1 font-weight-bold">Ekokardiografi</div>
                  <div v-for="(item, idx) in ekokardiografiKategori" :key="idx">
                    <v-span v-if="val.ekokardiografi[item.index] !== null">
                      <v-span v-if="val.ekokardiografi[item.index] === true"
                        ><v-icon>mdi-check</v-icon> {{ item.name }}
                      </v-span>

                      <v-span
                        v-else-if="val.ekokardiografi[item.index] === false"
                        ><v-icon>mdi-close</v-icon> {{ item.name }}
                      </v-span>

                      <v-span v-else
                        >{{ item.name }}:
                        {{ val.ekokardiografi[item.index] }}</v-span
                      >
                    </v-span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="text-body-1 font-weight-bold">ECG</div>
                  <div v-for="(item, idx) in ecgKategori" :key="idx">
                    <v-span v-if="val.ecg[item.index] !== null">
                      <v-span v-if="val.ecg[item.index] === true"
                        ><v-icon>mdi-check</v-icon> {{ item.name }}
                      </v-span>

                      <v-span v-else-if="val.ecg[item.index] === false"
                        ><v-icon>mdi-close</v-icon> {{ item.name }}
                      </v-span>

                      <v-span v-else
                        >{{ item.name }}: {{ val.ecg[item.index] }}</v-span
                      >
                    </v-span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <InputPreview2
                    title="Laboratorium"
                    :content="laboratoriumCategory"
                    :value="val.laboratorium"
                  ></InputPreview2>
                </v-col>
                <v-col cols="12">
                  <InputPreview2
                    title="Cath/MSC/Nuklir"
                    :content="cathCategory"
                    :value="val.cath"
                  ></InputPreview2>
                </v-col>
                <v-col cols="12">
                  <InputPreview2
                    title="Fungsi Ginjal"
                    :content="fungsiGinjalCategory"
                    :value="val.fungsiGinjal"
                  ></InputPreview2>
                </v-col>
                <v-col cols="12">
                  <InputPreview2
                    title="Keluaran (Ranap)"
                    :content="ranapOutcomeCategory"
                    :value="val.ranapOutcome"
                  ></InputPreview2>
                </v-col>
                <v-col cols="12">
                  <div class="text-body-1 font-weight-bold">QOL</div>
                  <div v-for="(item, idx) in qolCategory" :key="idx">
                    <v-span v-if="val.qol[item.index] !== null">
                      {{ item.label }}:
                      {{
                        val.qol[item.index]
                          ? val.qol[item.index].toUpperCase()
                          : "-"
                      }}
                    </v-span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="text-body-1 font-weight-bold">
                    Six Minute Walk Test
                  </div>
                  <div v-if="smwt">Mampu berjalan: {{ val.smwt }} meter</div>
                </v-col>
              </div>
            </v-hover>
          </template>
          <template v-else>
            <v-col cols="12" class="text-h6 font-weight-bold">{{
              val.hText
            }}</v-col>
            <v-col cols="12" class="font-weight-bold"> - </v-col>
          </template>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12" class="text-center"
          >Belum ada data yang bisa ditampilkan!</v-col
        >
      </v-row>
    </div>

    <ModalKonfirmasi
      v-model="dialogShow"
      :msg="dialogMsg"
      @nextDialog="dialogOnConfirm"
    ></ModalKonfirmasi>

    <RegisterHfEditModal
      v-model="editModalShow"
      :data="regHfData"
      @successUpdate="reloadData"
    ></RegisterHfEditModal>
  </div>
</template>

<script>
import registerHf from "@/services/registerHf";
import { storePasien } from "@/store/modules/pasien";
import InputPreview2 from "../reg_hf/InputPreview2.vue";
import moment from "moment";
import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";
import RegisterHfEditModal from "@/components/reg_hf/RegisterHfEditModal.vue";

export default {
  name: "RegisterHfHistory",
  props: {
    penampilanKlinisKategori: Array,
    statusGiziCategory: Array,
    optimalisasiDosisCategory: Array,
    ekokardiografiKategori: Array,
    ecgKategori: Array,
    qolCategory: Array,
    nyhaClassCategory: Array,
    laboratoriumCategory: Array,
    cathCategory: Array,
    fungsiGinjalCategory: Array,
    ranapOutcomeCategory: Array,
    loadRiwayat: {
      type: Boolean,
      require: false
    }
  },
  components: {
    InputPreview2,
    ModalKonfirmasi,
    RegisterHfEditModal
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      record: [],
      loadingRecord: false,
      categoryH: [
        { text: "H-0", value: 0 },
        { text: "H-30", value: 30 },
        { text: "H-6Bln", value: 180 },
        { text: "H-1Thn", value: 360 },
        { text: "H-2Thn", value: 720 },
        { text: "H-3Thn", value: 1080 },
        { text: "H-5Thn", value: 1800 }
      ],
      dialogShow: false,
      dialogMsg: null,
      dialogOnConfirm: null,
      editModalShow: false,
      regHfData: null,
      deleting: false
    };
  },
  computed: {
    history() {
      return this.record.map((val, index) => {
        return {
          id: val.id,
          diagnosis: val.diagnosis,
          pengobatan: val.pengobatan,
          penampilanKlinis: this.penampilanKlinisKategori.reduce(
            (o, key) => ({ ...o, [key.index]: this.record[index][key.index] }),
            {}
          ),
          statusGizi: this.statusGiziCategory.reduce(
            (o, key) => ({ ...o, [key.index]: this.record[index][key.index] }),
            {}
          ),
          optimalisasiDosis: this.optimalisasiDosisCategory.reduce(
            (o, key) => ({ ...o, [key.index]: this.record[index][key.index] }),
            {}
          ),
          ekokardiografi: this.ekokardiografiKategori.reduce(
            (o, key) => ({ ...o, [key.index]: this.record[index][key.index] }),
            {}
          ),
          ecg: this.ecgKategori.reduce(
            (o, key) => ({ ...o, [key.index]: this.record[index][key.index] }),
            {}
          ),
          laboratorium: val.laboratorium,
          qol: val.qol,
          smwt: val.smwt,
          follow_up: val.follow_up,
          examined_at: val.examined_at,
          h: val.h,
          hText: this.categoryH.find(item => item.value == val.h)?.text,
          cath: val.cath,
          fungsiGinjal: val.fungsi_ginjal,
          ranapOutcome: val.ranap_outcome
        };
      });
    },
    reportItems() {
      const resp = [];

      this.categoryH.map(h => {
        const print = this.history.filter(item => {
          return item.h.toString() == h.value.toString();
        });

        if (print.length) resp.push(...print);
        else resp.push({ hText: h.text, h: h.value });
      });

      return resp;
    },
    rm() {
      return storePasien.identitasPasien.rm;
    }
  },
  watch: {
    loadRiwayat: {
      handler(val) {
        if (val) {
          this.getData();
        }
        console.log(val);
      }
    },
    editModalShow: {
      handler(val) {
        if (!val) {
          this.regHfData = null;
        }
      }
    }
  },
  methods: {
    getData() {
      this.loadingRecord = true;

      registerHf
        .getByPasien(this.rm)
        .then(response => {
          this.record = response;
          console.log(response);
        })
        .finally(() => {
          this.loadRiwayat = false;
          this.loadingRecord = false;
        });
    },
    formatDate(tgl) {
      return moment(tgl).format("DD-MM-YYYY");
    },
    deleteItem(id) {
      this.dialogMsg = "Hapus item ini?";
      this.dialogOnConfirm = () => {
        if (!this.deleting) {
          this.deleting = true;
          registerHf
            .deleteRegHfItem(id)
            .then(resp => {
              if (resp.status) {
                this.getData();
              } else {
                alert("Ada kesalahan saat menghapus data, coba ulangi lagi!");
              }
            })
            .finally(() => {
              this.deleting = false;
            });
        } else {
          alert(
            "Proses menghapus sedang berjalan. Coba reload kembali browser Anda."
          );
        }
      };
      this.dialogShow = true;
    },
    editItem(id) {
      this.regHfData = this.record.find(item => item.id === id);
      this.editModalShow = true;
    },
    reloadData() {
      this.getData();
    }
  }
};
</script>
